<template>
  <a :href="ctaLink" :class="linkStyles">
    {{ ctaLabel }}
  </a>
</template>

<script setup lang="ts">
import { computed, toRefs } from "vue";

const props = defineProps<{
  ctaLabel?: string;
  ctaLink?: string;
  classes?: string;
}>();

const { ctaLink, ctaLabel, classes } = toRefs(props);

const linkStyles = computed(() => {
  return `pb-5 lg:pb-8 text-nav-mobile font-bold lg:text-nav text-white ${classes?.value} transition-all`;
});
</script>
